export const PREVIEW_WORKFLOW_ROUTING_ACTION_NAME = '';
export const DEFAULT_WORKFLOW_ROUTING_PRECEDENCE_INDEX = 1;
